import React, { useState, useEffect } from "react";
import axios from "axios";
import style from "../../css/admin/Notification.module.css";
import { API_BASE_URL } from "../ApiConfig";
import { getSecureToken } from "../ApisService/apiService";

const SendNotification = () => {
  const [message, setMessage] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
      const { secrettoken, ts } = await getSecureToken();
    try {
      const response = await axios.get(`${API_BASE_URL}notification/featch_notification.php`, {
      withCredentials: true,
        headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    }
    });
      setNotifications(response.data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const sendNotification = async () => {
    if (message.trim() === "") {
      alert("Message cannot be empty");
      return;
    }

    setLoading(true);
      const { secrettoken, ts } = await getSecureToken();
    try {
      const formData = new FormData();
      formData.append("message", message);

      const response = await axios.post(`${API_BASE_URL}notification/send_notification.php`, formData, {
      withCredentials: true,
        headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    }
    });

      if (response.data.success) {
        setMessage("");
        fetchNotifications();
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error sending notification:", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteNotification = async (id) => {
      const { secrettoken, ts } = await getSecureToken();
    try {
      const formData = new FormData();
      formData.append("id", id);

      const response = await axios.post(`${API_BASE_URL}notification/delete_notification.php`, formData, {
      withCredentials: true,
        headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    }
    });

      if (response.data.success) {
        fetchNotifications();
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  return (
    <div className={style.notificationContainer}>
      <h2 className={style.heading}>📢 Send Notification</h2>

      <div className={style.messageBox}>
        <textarea
          placeholder="Enter notification message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows="4"
          className={style.textArea}
        />
        <button 
          onClick={sendNotification} 
          disabled={loading}
          className={style.sendButton}
        >
          {loading ? "Sending..." : "Send Notification"}
        </button>
      </div>

      <h3 className={style.subHeading}>📜 All Notifications</h3>

      <div className={style.notificationList}>
        {notifications.length === 0 ? (
          <p className={style.noData}>🚫 No notifications available.</p>
        ) : (
          notifications.map((notification) => (
            <div key={notification.id} className={style.notificationItem}>
              <p className={style.message}>{notification.message}</p>
              <span className={style.timestamp}>{new Date(notification.created_at).toLocaleString()}</span>
              <button 
                onClick={() => deleteNotification(notification.id)} 
                className={style.deleteButton}
              >
                Delete
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SendNotification;
